import { useTranslation } from 'react-i18next';
import { XMarkIcon } from '@heroicons/react/24/outline';
import cn from 'classnames';

import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import useIsMobileViewport from 'hooks/useIsMobileViewport.hook';
import { useTheme } from 'providers/Theme.provider';

import CN from './ReactivateFormModal.module.scss';

export const ReactivateFormModal = ({ isOpen, onClose, onConfirm, formName, ruleTags }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const isMobile = useIsMobileViewport();

  return (
    <SalonModal
      tag="ReactivateFormModal"
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      shouldCloseOnEsc
      onClose={onClose}
      fullWidth={!isMobile}
      customClass={cn(CN.modalDialog, { [CN.darkMode]: isDarkMode })}
    >
      <SalonModal.Header>
        <div data-bem="ReactivateFormModal__header" className={CN.modalHeader}>
          <Button variant="icon" tag="ReactivateFormModal__close" className={CN.closeButton} onClick={onClose}>
            <XMarkIcon className={CN.closeIcon} />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <div className={CN.heading}>
          <h2 className={CN.title}>{t('consultationForms.reactivateModal.title')}</h2>
          <p className={CN.message}>
            {t('consultationForms.reactivateModal.message')} <strong>&lsquo;{formName}&rsquo;</strong>?
          </p>
        </div>
        {ruleTags && ruleTags.length > 0 && (
          <>
            <p className={CN.willSendWith}>{t('consultationForms.reactivateModal.willSendWith')}</p>
            <ul data-bem="ReactivateFormModal__rulesList" className={CN.rulesList}>
              {ruleTags.map((ruleTag) => (
                <li key={`${ruleTag.category}-${ruleTag.label}`} className={CN.ruleRow}>
                  <span className={CN.ruleCategory}>{ruleTag.category}</span>
                  <span className={CN.ruleValue}>{ruleTag.label}</span>
                </li>
              ))}
            </ul>
          </>
        )}
      </SalonModal.Body>
      <SalonModal.Footer>
        <Button variant="tertiary" onClick={onClose} tag="ReactivateFormModal__cancel">
          {t('consultationForms.cancel')}
        </Button>
        <Button variant="primaryForce" onClick={onConfirm} tag="ReactivateFormModal__confirm">
          {t('consultationForms.reactivateModal.confirm')}
        </Button>
      </SalonModal.Footer>
    </SalonModal>
  );
};
